import React, { Component, useEffect, useRef, useState } from 'react'
import { Row, Col, Button, Card } from 'reactstrap'
import Infobox from '../../components/Infos/Infobox'
import withAppdata from '../../components/AppConfig/withAppdata'
import {
  TextField,
  Divider,
  Switch,
  Autocomplete,
} from '@mui/material'
import TinyEditor from '../../components/Editor/TinyEditor'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker'

import { SERVICES } from '../../sports'

// Fix for mapbox-gl with webpack 5 (CRA 5+)
mapboxgl.workerClass = MapboxWorker

const INITIAL_CENTER = [-74.0242, 40.6941]
const INITIAL_ZOOM = 10.12

function MapboxContainer(props) {
  const mapRef = useRef()
  const mapContainerRef = useRef()
  const markerRef = useRef()

  // Initialize map
  useEffect(() => {
    mapboxgl.accessToken =
      'pk.eyJ1IjoiY2ludG9pYS1hZG1pbiIsImEiOiJjbWpjbHptdTkwZ25wM2ZzY2hianVlYzhlIn0.apYRqjs29d2a-hPD1eSyfQ'

    const initialCenter = props.lng && props.lat ? [props.lng, props.lat] : INITIAL_CENTER

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: initialCenter,
      zoom: INITIAL_ZOOM,
    })

    mapRef.current.addControl(new mapboxgl.NavigationControl(), 'top-right')

    // Add marker if coordinates exist
    if (props.lng && props.lat) {
      markerRef.current = new mapboxgl.Marker({ color: '#51cbce' })
        .setLngLat([props.lng, props.lat])
        .addTo(mapRef.current)
    }

    // Add click handler to set location
    mapRef.current.on('click', (e) => {
      const { lng, lat } = e.lngLat

      // Update or create marker
      if (markerRef.current) {
        markerRef.current.setLngLat([lng, lat])
      } else {
        markerRef.current = new mapboxgl.Marker({ color: '#51cbce' })
          .setLngLat([lng, lat])
          .addTo(mapRef.current)
      }

      // Call callback if provided
      if (props.onLocationSelect) {
        props.onLocationSelect({ lat, lng })
      }
    })

    return () => {
      if (markerRef.current) markerRef.current.remove()
      mapRef.current.remove()
    }
  }, [])

  // Update map when coordinates change
  useEffect(() => {
    if (mapRef.current && props.lng && props.lat) {
      // Fly to new location
      mapRef.current.flyTo({
        center: [props.lng, props.lat],
        zoom: 14,
        essential: true
      })

      // Update or create marker
      if (markerRef.current) {
        markerRef.current.setLngLat([props.lng, props.lat])
      } else {
        markerRef.current = new mapboxgl.Marker({ color: '#51cbce' })
          .setLngLat([props.lng, props.lat])
          .addTo(mapRef.current)
      }
    }
  }, [props.lat, props.lng])

  return (
    <>
      <div
        id='map-container'
        ref={mapContainerRef}
        style={{ width: '100%', height: '500px', backgroundColor: 'lightgrey', display: 'block', visibility: 'visible' }}
      />
    </>
  )
}



function VenueLocation(props) {
  const { venue } = props
  const [venueData, setVenueData] = useState(venue)
  const [changedAfterSave, setChangedAfterSave] = useState(false)
  if (!venue) {
    return null
  }

  const findAddressCoordinates = async () => {
    const address = `${venueData.address}, ${venueData.zipcode},  ${venueData.city}, ${venueData.country}`
    const features = await fetchAddressCoordinates(address)
    if (features && features.length > 0) {
      const first = features[0]
      console.log('First geocoding result:', first.properties)
      if (
        first.properties &&
        first.properties.match_code &&
        first.properties.match_code.street === 'matched' &&
        first.properties.match_code.place === 'matched'
      ) {
        setVenueData({
          ...venueData,
          lat: first.properties.coordinates.latitude,
          lng: first.properties.coordinates.longitude,
        })
      } else {
        alert('Osoitetta ei löydetty tarkasti. Tarkenna osoitetta.')
      }
    } else {
      alert('Osoitetta ei löydetty. Tarkenna osoitetta.')
    }
  }

  const fetchAddressCoordinates = async (address) => {
    // fetch coordinates from mapbox geocoding api
    const apiUrl =
      'https://api.mapbox.com/search/geocode/v6/forward?access_token=pk.eyJ1IjoiY2ludG9pYS1hZG1pbiIsImEiOiJjbWpjbHptdTkwZ25wM2ZzY2hianVlYzhlIn0.apYRqjs29d2a-hPD1eSyfQ'
    const response = await fetch(
      `${apiUrl}&q=${encodeURIComponent(address)}&limit=3`
    )
    const data = await response.json()
    console.log('Geocoding response data:', data.features)
    return data.features
  }

  const handleServiceOptionLabel = (option) => {
    return option.labels.fi
  }

  const updateVenueData = (newData) => {
    setVenueData({ ...venueData, ...newData })
    setChangedAfterSave(true)
  }

  return (
    <>
      <Card body style={{ marginBottom: 10 }}>
        <Row>
          <Col xs={12} md={4}></Col>
        </Row>
        <Row>
          <Col xs={12} md={8}>
            <TextField
              label='Nimi'
              value={venueData.name || ''}
              onChange={(e) =>
                updateVenueData({ name: e.target.value })
              }
              fullWidth
              margin='normal'
            />
          </Col>
          <Col xs={12} md={4}>
            <Switch
              checked={venueData.default || false}
              onChange={(e) =>
                updateVenueData({ default: e.target.checked })
              }
              name='defaultVenue'
              color='primary'
            />
            Pääpaikka
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col xs={12} md={3}>
            <TextField
              label='Osoite'
              value={venueData.address || ''}
              onChange={(e) =>
                updateVenueData({ address: e.target.value })
              }
              fullWidth
              margin='normal'
            />
          </Col>
          <Col xs={12} md={3}>
            <TextField
              label='Kaupunki'
              value={venueData.city || ''}
              onChange={(e) =>
                updateVenueData({ city: e.target.value })
              }
              fullWidth
              margin='normal'
            />
          </Col>
          <Col xs={12} md={3}>
            <TextField
              label='Postinumero'
              value={venueData.zipcode || ''}
              onChange={(e) =>
                updateVenueData({ zipcode: e.target.value })
              }
              fullWidth
              margin='normal'
            />
          </Col>
          <Col xs={12} md={3}>
            <TextField
              label='Maa'
              value={venueData.country || 'Suomi'}
              onChange={(e) =>
                updateVenueData({ country: e.target.value })
              }
              fullWidth
              margin='normal'
            />
          </Col>
          <Col xs={12} md={12}>
            <Button
              color='secondary'
              onClick={() => {
                findAddressCoordinates()
              }}
            >
              Hae koordinaatit osoitteella
            </Button>
          </Col>
          <Col xs={12}>
            <MapboxContainer
              lat={venueData.lat}
              lng={venueData.lng}
              onLocationSelect={(coords) => updateVenueData({ lat: coords.lat, lng: coords.lng })}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col>
            <TextField
              label='Puhelin'
              value={venueData.phone || ''}
              onChange={(e) =>
                updateVenueData({ phone: e.target.value })
              }
              fullWidth
              margin='normal'
            />
          </Col>
          <Col>
            <TextField
              label='Sähköposti'
              value={venueData.email || ''}
              onChange={(e) => {
                updateVenueData({ email: e.target.value })
              }

              }
              fullWidth
              margin='normal'
            />
          </Col>
          <Col>
            <TextField
              label='Kotisivut'
              value={venueData.homepage || ''}
              onChange={(e) => {
                updateVenueData({ homepage: e.target.value })
              }
              }
              fullWidth
              margin='normal'
            />
          </Col>
        </Row>
        <Divider />

        {venueData.default &&
          <TinyEditor
            disableSave={true}
            onChange={(content) => {
              updateVenueData({ description: content })
          }}
          defaultValue={venueData.description || ''}
          />}
        <Row>
          <Col>
            <Autocomplete
              multiple
              options={SERVICES}
              getOptionLabel={handleServiceOptionLabel} // {option => option.name}
              onChange={(e, value) => {
                updateVenueData({ services: value })
              }}
              getOptionSelected={(option, val) => {
                return option.value === val.value
              }}
              value={venueData.services ? venueData.services : []}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant='standard'
                  label='Lisää palvelut'
                  margin='normal'
                  fullWidth
                />
              )}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col>
            {(venueData.infos &&
              venueData.infos.map((info, index) => (
                <div key={index}>
                  <TextField
                    label={`Info ${index + 1}`}
                    value={info}
                    onChange={(e) => {
                      const newInfos = [...venueData.infos]
                      newInfos[index] = e.target.value
                      updateVenueData({ infos: newInfos })
                    }}
                    fullWidth
                    margin='normal'
                  />
                </div>
              ))) || (
              <TextField
                label='Info 1'
                value={''}
                onChange={(e) => {
                  updateVenueData({ infos: [e.target.value] })
                }}
                fullWidth
                margin='normal'
              />
            )}
          </Col>
        </Row>
        <Button
          color='primary'
          onClick={() => {
            props.onSave(venueData)
            setChangedAfterSave(false)
          }}
          disabled={props.saving || !changedAfterSave}
        >
          Tallenna
        </Button>
      </Card>
    </>
  )
}

class VenuepageContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      venues: [],
      saving: false,
    }
  }

  handleSaveVenue = (venue) => {
    console.log('Saving venue', venue)
    this.setState({ saving: true })
    if (venue.id) {
      this.props.firebase
        .updateVenueLocation(venue)
        .then(() => {
          this.setState({ saving: false })
          this.fetchVenues()
        })
        .catch((err) => {
          console.error('Error updating venue location:', err)
          this.setState({ saving: false })
        })
    } else {
      this.props.firebase
        .addVenueLocation(venue)
        .then(() => {
          this.setState({ saving: false })
          this.fetchVenues()
        })
        .catch((err) => {
          console.error('Error adding venue location:', err)
          this.setState({ saving: false })
        })
    }
  }

  fetchVenues = async () => {
    // Logic to fetch venues from backend or Firebase
    const venues = await this.props.firebase.getVenueLocations()
    // default country to Suomi
    venues.forEach((venue) => {
      if (!venue.country) {
        venue.country = 'Suomi'
      }
    })
    this.setState({ venues })
  }

  componentDidMount() {
    this.fetchVenues()
  }

  addVenue = () => {
    const newVenue = { name: '',
      address: '',
      city: '',
      zipcode: '',
      country: 'Suomi',
      lat: null,
      lng: null,
      phone: '',
      email: '',
      homepage: '',
      services: [],
      infos: [],
    }
    this.setState({ venues: [...this.state.venues, newVenue] })
  }

  render() {
    return (
      <div className='content'>
        <Row>
          <Col>
            <Button onClick={this.addVenue}>Lisää sijainti</Button>
          </Col>
          <Col>
            <Infobox index={'0'} />
          </Col>
        </Row>
        <Row>
          {' '}
          {this.state.venues.map((venue) => (
            <Col key={venue.id}>
              <VenueLocation
                venue={venue}
                onSave={this.handleSaveVenue}
                saving={this.state.saving}
              />
            </Col>
          ))}
        </Row>
      </div>
    )
  }
}

export default withAppdata(VenuepageContainer)
